import { Scene } from 'phaser';
import { abrirVisualizadorDeMaterial } from '../components/visualizadorDeMaterial';
import { desenharPaginaLima, desenharVoltar } from '../components/cenario';
import { criarTextoRico } from '../components/TextoRico';
import { SCENES, TEX } from '../config/constants';
import { ARCADE, ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { celulasDaLinha, escalaDoRotulo, rotuloDaPasta } from '../services/materiaisLayout';
import { Sessao } from '../services/Sessao';
import { t } from '../services/textos';


const POR_LINHA = 4;

/** 3. Materiais (Figma, quadro 45): biblioteca com desbloqueio progressivo. */
export class MateriaisScene extends Scene {
    constructor () {
        super(SCENES.MATERIAIS);
    }

    /** `voltarPara`: cena que abriu esta página (uma fase em andamento, por exemplo). */
    init (dados = {}) {
        this.voltarPara = dados.voltarPara ?? SCENES.AGUARDE;
    }

    async create () {
        if (!Sessao.ativa) {
            this.scene.start(SCENES.LOGIN);
            return;
        }

        desenharPaginaLima(this, { titulo: t('materiais.titulo'), rotuloJogador: Sessao.rotulo });
        desenharVoltar(this, 62, 185, () => this.scene.start(this.voltarPara, {}));
        this.add.rectangle(62, 216, 1156, 1, ARCADE_HEX.TINTA).setOrigin(0, 0.5);
        criarTextoRico(this, 60, 242, 1160, t('materiais.introducao'), ARCADE_TEXT.introducao);

        let materiais;
        try {
            materiais = await this.registry.get('fonte').obterMateriais();
        } catch (falha) {
            console.error('[Materiais] não foi possível carregar a biblioteca.', falha);
            if (this.scene.isActive()) {
                this.add.text(640, 520, t('materiais.erro_carregar'), ARCADE_TEXT.aviso)
                    .setOrigin(0.5);
            }
            return;
        }
        if (!this.scene.isActive()) return;

        for (let inicio = 0, linha = 0; inicio < materiais.length; inicio += POR_LINHA, linha++) {
            this.desenharLinha(materiais.slice(inicio, inicio + POR_LINHA), 394 + linha * 198);
        }
    }

    /** Uma linha de pastas, centralizada: células de mesma largura, sempre dentro da página. */
    desenharLinha (materiais, topo) {
        const { largura, centros } = celulasDaLinha(materiais.length);

        materiais.forEach((material, i) => {
            const centro = centros[i];
            // RI-MAT-01 / RI-MAT-02: cinza com cadeado × colorido.
            const icone = this.add.image(
                centro, topo + (material.desbloqueado ? 0 : 4),
                material.desbloqueado ? TEX.PASTA_ABERTA : TEX.PASTA_BLOQUEADA
            ).setOrigin(0.5, 0);
            const rotulo = this.add.text(centro, topo + 111, rotuloDaPasta(material.titulo), {
                ...ARCADE_TEXT.rotuloMaterial,
                color: material.desbloqueado ? ARCADE.TINTA : ARCADE.TINTA_APAGADA
            }).setOrigin(0.5, 0);
            rotulo.setScale(escalaDoRotulo(rotulo.width, largura));

            // RN-MAT-03: bloqueado não abre — nem recebe toque.
            if (material.desbloqueado) {
                this.add.zone(centro, topo + 78, largura, 170)
                    .setInteractive({ useHandCursor: true })
                    .on('pointerdown', () => icone.setScale(0.94))
                    .on('pointerout', () => icone.setScale(1))
                    .on('pointerup', () => {
                        icone.setScale(1);
                        this.abrirMaterial(material);
                    });
            }
        });
    }

    /** RI-MAT-03: abre o documento no visualizador. */
    abrirMaterial (material) {
        if (this.visualizador) return;
        this.visualizador = abrirVisualizadorDeMaterial(this, material, {
            aoFechar: () => { this.visualizador = null; }
        });
    }
}
